//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
var script = {
  name: "Checkbox",
  props: {
    text: String,
    value: {
      type: Boolean,
      default: () => null
    },
    disabled: {
      type: Boolean,
      default: () => null
    },
    hasError: {
      type: [Boolean, String],
      default: () => null
    },
    headline: {
      type: String,
      default: () => ""
    },
    disabledBgColor: {
      type: String,
      default: () => "bg-secondary-5"
    },
    checkedBgColor: {
      type: String,
      default: () => "bg-white"
    },
    icon: {
      type: String,
      default: () => ""
    }
  },

  data() {
    return {
      model: this.value,
      id: Math.random().toString(36)
    };
  },

  watch: {
    model(val) {
      this.$emit("input", val);
    },

    value(val) {
      this.model = val;
    }

  }
};

function normalizeComponent(template, style, script, scopeId, isFunctionalTemplate, moduleIdentifier /* server only */, shadowMode, createInjector, createInjectorSSR, createInjectorShadow) {
    if (typeof shadowMode !== 'boolean') {
        createInjectorSSR = createInjector;
        createInjector = shadowMode;
        shadowMode = false;
    }
    // Vue.extend constructor export interop.
    const options = typeof script === 'function' ? script.options : script;
    // render functions
    if (template && template.render) {
        options.render = template.render;
        options.staticRenderFns = template.staticRenderFns;
        options._compiled = true;
        // functional template
        if (isFunctionalTemplate) {
            options.functional = true;
        }
    }
    // scopedId
    if (scopeId) {
        options._scopeId = scopeId;
    }
    let hook;
    if (moduleIdentifier) {
        // server build
        hook = function (context) {
            // 2.3 injection
            context =
                context || // cached call
                    (this.$vnode && this.$vnode.ssrContext) || // stateful
                    (this.parent && this.parent.$vnode && this.parent.$vnode.ssrContext); // functional
            // 2.2 with runInNewContext: true
            if (!context && typeof __VUE_SSR_CONTEXT__ !== 'undefined') {
                context = __VUE_SSR_CONTEXT__;
            }
            // inject component styles
            if (style) {
                style.call(this, createInjectorSSR(context));
            }
            // register component module identifier for async chunk inference
            if (context && context._registeredComponents) {
                context._registeredComponents.add(moduleIdentifier);
            }
        };
        // used by ssr in case component is cached and beforeCreate
        // never gets called
        options._ssrRegister = hook;
    }
    else if (style) {
        hook = shadowMode
            ? function (context) {
                style.call(this, createInjectorShadow(context, this.$root.$options.shadowRoot));
            }
            : function (context) {
                style.call(this, createInjector(context));
            };
    }
    if (hook) {
        if (options.functional) {
            // register for functional component in vue file
            const originalRender = options.render;
            options.render = function renderWithStyleInjection(h, context) {
                hook.call(context);
                return originalRender(h, context);
            };
        }
        else {
            // inject component registration as beforeCreate hook
            const existing = options.beforeCreate;
            options.beforeCreate = existing ? [].concat(existing, hook) : [hook];
        }
    }
    return script;
}

const isOldIE = typeof navigator !== 'undefined' &&
    /msie [6-9]\\b/.test(navigator.userAgent.toLowerCase());
function createInjector(context) {
    return (id, style) => addStyle(id, style);
}
let HEAD;
const styles = {};
function addStyle(id, css) {
    const group = isOldIE ? css.media || 'default' : id;
    const style = styles[group] || (styles[group] = { ids: new Set(), styles: [] });
    if (!style.ids.has(id)) {
        style.ids.add(id);
        let code = css.source;
        if (css.map) {
            // https://developer.chrome.com/devtools/docs/javascript-debugging
            // this makes source maps inside style tags work properly in Chrome
            code += '\n/*# sourceURL=' + css.map.sources[0] + ' */';
            // http://stackoverflow.com/a/26603875
            code +=
                '\n/*# sourceMappingURL=data:application/json;base64,' +
                    btoa(unescape(encodeURIComponent(JSON.stringify(css.map)))) +
                    ' */';
        }
        if (!style.element) {
            style.element = document.createElement('style');
            style.element.type = 'text/css';
            if (css.media)
                style.element.setAttribute('media', css.media);
            if (HEAD === undefined) {
                HEAD = document.head || document.getElementsByTagName('head')[0];
            }
            HEAD.appendChild(style.element);
        }
        if ('styleSheet' in style.element) {
            style.styles.push(code);
            style.element.styleSheet.cssText = style.styles
                .filter(Boolean)
                .join('\n');
        }
        else {
            const index = style.ids.size - 1;
            const textNode = document.createTextNode(code);
            const nodes = style.element.childNodes;
            if (nodes[index])
                style.element.removeChild(nodes[index]);
            if (nodes.length)
                style.element.insertBefore(textNode, nodes[index]);
            else
                style.element.appendChild(textNode);
        }
    }
}

/* script */
const __vue_script__ = script;
/* template */

var __vue_render__ = function () {
  var _vm = this;

  var _h = _vm.$createElement;

  var _c = _vm._self._c || _h;

  return _c('div', {
    staticClass: "input-group"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: _vm.model,
      expression: "model"
    }],
    staticClass: "checkbox option-input",
    attrs: {
      "type": "checkbox",
      "id": _vm.id,
      "disabled": _vm.disabled
    },
    domProps: {
      "checked": Array.isArray(_vm.model) ? _vm._i(_vm.model, null) > -1 : _vm.model
    },
    on: {
      "change": function ($event) {
        var $$a = _vm.model,
            $$el = $event.target,
            $$c = $$el.checked ? true : false;

        if (Array.isArray($$a)) {
          var $$v = null,
              $$i = _vm._i($$a, $$v);

          if ($$el.checked) {
            $$i < 0 && (_vm.model = $$a.concat([$$v]));
          } else {
            $$i > -1 && (_vm.model = $$a.slice(0, $$i).concat($$a.slice($$i + 1)));
          }
        } else {
          _vm.model = $$c;
        }
      }
    }
  }), _vm._v(" "), _c('label', {
    staticClass: "d-flex m-0",
    attrs: {
      "for": _vm.id
    }
  }, [_c('span', {
    staticClass: "mt-1 pr-3",
    class: [_vm.disabled && _vm.model ? _vm.disabledBgColor : '', !_vm.disabled && !_vm.hasError && _vm.model ? _vm.checkedBgColor : '', {
      'bg-secondary-5': _vm.disabled && !_vm.model,
      'bg-secondary-10 border-color--primary-5': _vm.hasError
    }]
  }, [_vm.model && !_vm.icon ? _c('em', {
    staticClass: "ic-check"
  }) : _vm._e(), _vm._v(" "), _vm.model && _vm.icon ? _c('em', {
    class: [_vm.disabled ? _vm.disabledBgColor : '', _vm.icon, 'icon']
  }) : _vm._e()]), _vm._v(" "), _c('div', [_vm.headline ? _c('label', {
    staticClass: "color-black font-weight-bold mb-n1",
    attrs: {
      "for": _vm.id
    }
  }, [_vm._v(_vm._s(_vm.headline))]) : _vm._e(), _vm._v("\n      " + _vm._s(_vm.text) + "\n    ")])])]);
};

var __vue_staticRenderFns__ = [];
/* style */

const __vue_inject_styles__ = function (inject) {
  if (!inject) return;
  inject("data-v-4b95b832_0", {
    source: ".input-group .option-input[data-v-4b95b832]{display:none}.input-group .option-input+label span[data-v-4b95b832]{display:inline-block;width:20px;height:20px;margin:-2px 10px 0 0;vertical-align:middle;border:1px solid #e2e2e2;border-radius:4px;cursor:pointer}.input-group .option-input:checked+label span .ic-check[data-v-4b95b832]{background-image:url(\"data:image/svg+xml,%3C%3Fxml version='1.0' encoding='utf-8'%3F%3E%3C!-- Generator: Adobe Illustrator 23.1.1, SVG Export Plug-In . SVG Version: 6.00 Build 0) --%3E%3Csvg version='1.1' id='Layer_1' focusable='false' xmlns='http://www.w3.org/2000/svg' xmlns:xlink='http://www.w3.org/1999/xlink' x='0px' y='0px' viewBox='0 0 14 10' style='enable-background:new 0 0 14 10;' xml:space='preserve'%3E%3Cstyle type='text/css'%3E .st0%7Bfill:%232DB782;%7D%0A%3C/style%3E%3Cpath class='st0' d='M5.6,7.8L2.9,5.1C2.7,5,2.7,4.7,2.9,4.5L3.5,4c0.2-0.2,0.4-0.2,0.6,0l1.8,1.8l3.9-3.9c0.2-0.2,0.4-0.2,0.6,0 l0.6,0.6c0.2,0.2,0.2,0.4,0,0.6L6.2,7.8C6,8,5.7,8,5.6,7.8L5.6,7.8z'/%3E%3C/svg%3E%0A\");background-size:cover;display:flex;width:18px;height:14px;margin:2px auto}.input-group .option-input:checked+label span .icon[data-v-4b95b832]{display:flex;margin:2px 3px;color:#fff;font-size:13px}",
    map: undefined,
    media: undefined
  });
};
/* scoped */


const __vue_scope_id__ = "data-v-4b95b832";
/* module identifier */

const __vue_module_identifier__ = undefined;
/* functional template */

const __vue_is_functional_template__ = false;
/* style inject SSR */

/* style inject shadow dom */

const __vue_component__ = /*#__PURE__*/normalizeComponent({
  render: __vue_render__,
  staticRenderFns: __vue_staticRenderFns__
}, __vue_inject_styles__, __vue_script__, __vue_scope_id__, __vue_is_functional_template__, __vue_module_identifier__, false, createInjector, undefined, undefined);

// Import vue component

const install = function installCheckBox(Vue) {
  if (install.installed) return;
  install.installed = true;
  Vue.component('CheckBox', __vue_component__);
}; // Create module definition for Vue.use()
// to be registered via Vue.use() as well as Vue.component()


__vue_component__.install = install; // Export component by default
// also be used as directives, etc. - eg. import { RollupDemoDirective } from 'rollup-demo';
// export const RollupDemoDirective = component;

export default __vue_component__;
